import http from "./http";

export const placeBetApi = (optionCode, amount) =>
    http.post("/api/player/bet/place", { optionCode, amount });

export const getBetByIssueApi = (issueNo) =>
    http.get(`/api/player/bet/issue/${encodeURIComponent(issueNo)}`);

export const getBetHistoryApi = (page = 0, size = 50) =>
    http.get("/api/player/bet/history", { params: { page, size } });
